import gql from 'graphql-tag';

export default gql`
    mutation MeasurementGroupDeleteMutation(
        $request: UserMeasurementGroupDeleteInputType
    ) {
        me {
            measurementGroupDelete(request: $request) {
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
